import { ModuleWithProviders, NgModule } from '@angular/core';

import { UtilsRefreshTokenServiceModule } from '@fitscovery/utils/refresh-token-service';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { TokenInterceptorProvider } from './token.interceptor';

@NgModule({
  imports: [
    UtilsRefreshTokenServiceModule
  ]
})
export class UtilsTokenInterceptorModule {

  public static forRoot(environment: Environment): ModuleWithProviders<UtilsTokenInterceptorModule> {
    return {
      ngModule: UtilsTokenInterceptorModule,
      providers: [
        TokenInterceptorProvider,
        { provide: APP_ENVIRONMENT, useValue: environment }
      ]
    };
  }
}

